import { styles } from './template.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';

import { styles as fonts } from '../../../../assets/fonts.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { InputWidthValues } from '../../../../ui/gzInput';

export const templateSettingsForm = document.createElement('template');
templateSettingsForm.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${fonts}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='form-wrapper' id='package-settings-form-wrapper'>
    <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle' id='settings-subtitle'></gz-title>

    <div class='form-section'>
        <div id='customInstalationPath' class='flex-group'>
            <gz-form-field id='useCustomPathFormField'>
                <gz-checkbox gz-form-input></gz-checkbox>
            </gz-form-field>
            <gz-form-field id='customPathInputFormField' disabled class='label-mw-250' label=''>
                <gz-input gz-form-input placeholder='' inputWidth='${InputWidthValues.LARGE}'></gz-input>
                <gz-input-error></gz-input-error>
            </gz-form-field>
        </div>
         <div id='settingsUninstallPasswordSectionGroup'>
            <gz-form-field id='settingsSetUninstallPasswordFormField'>
                <gz-checkbox gz-form-input></gz-checkbox>
            </gz-form-field>
            <div id='settingsPasswordSection' class='sub-module-section' hidden>
                <gz-form-field id='settingsPasswordFormField' class='label-mw-250 sub-module' label='' required>
                    <gz-input gz-form-input type='password' inputWidth='${InputWidthValues.LARGE}' ></gz-input>
                    <gz-input-error></gz-input-error>
                </gz-form-field>
                <gz-form-field id='settingsConfirmPasswordFormField' class='label-mw-250 sub-module' label='' required>
                    <gz-input gz-form-input type='password' inputWidth='${InputWidthValues.LARGE}' ></gz-input>
                    <gz-input-error></gz-input-error>
                    <gz-text fontSize='${FontSizes.PARAGRAPH_12}' id='password-info'></gz-text>
                </gz-form-field>
            </div>
        </div>
        <div id='settingsCustomFoldersSection'>
            <gz-form-field class='flex-group' id='settingsUseCustomFoldersFormField'>
                <gz-checkbox class='settingsUseCustomFolders' gz-form-input></gz-checkbox>
            </gz-form-field>
            <gz-targets id='settingsTargets' class='hidden'></gz-targets>
         </div>
    </div>
  </div>
`;
